import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {store} from './ui/app/store';
import {AppComponent} from './ui/app/AppComponent';
import reportWebVitals from './reportWebVitals';
import './index.css';
import {AppActions} from "./ui/app/AppActions";
import '@pledger/frontend-commons/dist/index.css';
import {Log, matchResponsive, PledgerAction} from "@pledger/frontend-commons";
import {pageManager} from "./services/ui/AppPageManager";


const container = document.getElementById('root')!;
const root = createRoot(container);


store.subscribe(() => {
    root.render(
            <Provider store={store}>
                <AppComponent store={store} state={store.getState()}/>
            </Provider>
    );
})
// StrictMode generata multiple call on methode in development mode...
/*
store.subscribe(() => {
    root.render(
            <Provider store={store}>
                <AppComponent store={store} state={store.getState()}/>
            </Provider>
    );
})
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


let loadURLAction: PledgerAction | undefined = undefined;

export const setLoadURLAction = (action? : PledgerAction) => {
    Log('setLoadURLAction : '+JSON.stringify(action));
    loadURLAction=action;
}

export const getLoadURLAction = () => {
    Log('getLoadURLAction : '+JSON.stringify(loadURLAction));
    return loadURLAction;
}

if (window.location.hash.length>0) {
    const hashURL = window.location.hash.substring(1);
   // const hashURL = window.location.pathname;
    const action  = pageManager.actionFromHashURL(hashURL);
    setLoadURLAction(action);
}

/*
if (null===sessionStorage.getItem('userToken')) {
    console.log("no token");
    setLoadURLAction(undefined);
    store.dispatch(ShowPageActions.SHOW_HOME_ACTION.build(true));
}
else

 */
if (loadURLAction!==undefined) {
    console.log(loadURLAction);
    store.dispatch(AppActions.REPLACE_LOCATION_ACTION.build(loadURLAction!));
}
else {
    store.dispatch(AppActions.RESTORE_LOCATION_ACTION.build());
}


store.dispatch(AppActions.MATCH_MEDIA_ACTION.build(matchResponsive()));
